/*=========================================================================================
  File Name: module-supplier-actions.js
  Description: Supplier Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getUserSetup(state) {
		return state.UserSetup;
	}
};
